import { EventEmitter, Injectable } from "@angular/core";
import { PlanData } from "@planard/@core/entities/interface/plan";
import { PlanApi } from "@planard/@core/backend/api/plan.api";
import { Plan } from "@planard/@core/entities/plan";

@Injectable()
export class PlanService extends PlanData {
  onPriceReload: EventEmitter<any> = new EventEmitter<any>();

  constructor(private api: PlanApi) {
    super();
  }

  listPrices(scenarioId: number, approveRequestId?: number) {
    return this.api.listPrices<any>(scenarioId, approveRequestId);
  }

  costTrend(data: any) {
    return this.api.costTrend<any>(data);
  }

  costOverview(data: any) {
    return this.api.costOverview<any>(data);
  }

  update(plan: Plan) {
    return this.api.update<any>(plan);
  }

  listApproverUsersSubDepartments() {
    return this.api.listApproverUsersSubDepartments<any>();
  }
}
